import React, {useState} from "react";
import {Container} from "react-bootstrap";
// import Sidebar from './Components/Sidebar/Sidebar';
// import './Components/Sidebar/Sidebar.css';
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";

function LandingPage () {
    return(
    <Container fluid className="clms-landing px-0">
        <Header />
        <Sidebar />
    </Container>)

}

export default LandingPage;